import { useEffect, useState } from 'react'
import { useAuthContext } from '../../../hooks/AuthContext'
import { BASE_URL } from '../../../env'
import PopupModal from './PopupModal'
import PhoneInput from 'react-phone-number-input'

const PhoneNumberModal = () => {
  const [phoneNum, setPhoneNum] = useState()
  const [enteredPhoneNum, setEnteredPhoneNum] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(true)
  const { state } = useAuthContext()

  const fetchUser = async () => {
    if (state.key) {
      const response = await fetch(`${BASE_URL}/api/v1/auth/user/`, {
        method: 'GET',
        headers: {
          accept: 'application/json',
          Authorization: `Token ${state.key}`,
        },
      })
      const responseData = await response.json()
      setPhoneNum(responseData.phone_number)
      setLoading(false)
    }
  }

  const submitPhoneNumber = async () => {
    if (state.key) {
      await fetch(`${BASE_URL}/api/v1/auth/user/`, {
        method: 'PATCH',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Token ${state.key}`,
        },
        body: JSON.stringify({ phone_number: enteredPhoneNum }),
      })
      closeModal()
    }
  }

  const closeModal = () => {
    const currentTimeStamp = new Date().getTime()
    localStorage.setItem('phoneModalClosedTime', currentTimeStamp.toString())
    setShowModal(false)
  }

  useEffect(() => {
    fetchUser()
  }, [state.key])

  useEffect(() => {
    if (!loading) {
      const lastClosedModalTime = localStorage.getItem('phoneModalClosedTime')
      const currentTimeStamp = new Date().getTime()
      const sevenDaysInMilliseconds = 7 * 24 * 60 * 60 * 1000

      if (phoneNum === null || phoneNum === '' || phoneNum === undefined) {
        if (!lastClosedModalTime || currentTimeStamp - Number(lastClosedModalTime) >= sevenDaysInMilliseconds) {
          setShowModal(true)
        }
      }
    }
  }, [phoneNum, loading])

  return (
    <PopupModal showModal={showModal} closeModal={closeModal}>
      <>
        <div className="text-[#201e57] text-xl font-medium leading-6 mb-6">
          Please enter your <br /> phone number
        </div>

        <div className="flex flex-col w-full">
          <label className="pop-up-fl">
            Phone Number
          </label>
          <PhoneInput
            className="pop-up-tf pl-3 outline-none h-[45px] bg-transparent rounded-md py-4 px-5 text-base leading-5"
            placeholder="Enter phone"
            value={enteredPhoneNum}
            onChange={setEnteredPhoneNum}
            international
            defaultCountry="US"
          />
          <button
            className="w-full bg-[#fd4367] flex items-center text-center justify-center h-[40px] hover:bg-[#7d42fb] transition px-6 py-1 rounded-lg text-white font-poppins"
            onClick={submitPhoneNumber}
          >
            Submit
          </button>
        </div>
      </>
    </PopupModal>
  )
}
export default PhoneNumberModal
